import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import TrustStats from "@/components/landing/TrustStats";
import InstantAudit from "@/components/landing/InstantAudit";
import Services from "@/components/landing/Services";
import AISolutions from "@/components/landing/AISolutions";
import CaseStudies from "@/components/landing/CaseStudies";
import Process from "@/components/landing/Process";
import Testimonials from "@/components/landing/Testimonials";
import FaqInsights from "@/components/landing/FaqInsights";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/landing/ChatWidget";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import MobileBottomNav from "@/components/landing/MobileBottomNav";

export default function Landing() {
  return (
    <main className="relative bg-[#050505] text-white selection:bg-cyan-400/20 pb-24 md:pb-0" data-testid="landing-page">
      <Nav />
      <Hero />
      <Marquee />
      <TrustStats />
      <InstantAudit />
      <Services />
      <AISolutions />
      <CaseStudies />
      <Process />
      <Testimonials />
      <FaqInsights />
      <FinalCTA />
      <Footer />
      <ChatWidget />
      <WhatsAppButton />
      <MobileBottomNav />
    </main>
  );
}
